export default "__VITE_ASSET__cd63f0b2__"